export namespace IAuth {
  export interface IState {
    token: string;
    profileName: string;
    userAccess: UserAccess;
    login: string;
    password: string;
    recoverPassword: string;
    isUser: boolean;
    isNewSession: boolean;
    isShowDialogSession: boolean;
    tokenWasChecked: boolean;
  }

  export interface UserAccess {
    token?: string;
    balance?: number;
    carsXParksFlag?: boolean;
    corpId?: number;
    corpName?: string;
    extModeFlag?: boolean;

    fillCarTypeFlag?: boolean;
    fillParkFlag?: boolean;
    fillTarifFlag?: boolean;

    fltCorpShowFlag?: boolean;
    fltParkIdFlag?: boolean;

    needOferta?: boolean;
    newVersion?: boolean;
    payGuestHours?: number;
    persName?: string;
    refFlag?: boolean;
    ourCorp?: boolean;

    scCarMk?: boolean;
    scChangeTarif?: boolean;
    scCreateAccountByCarFlag?: boolean;
    scCreateAccountDefaultFlag?: boolean;
    scCarsUnion?: boolean;
    scDashBoard?: boolean;
    scFltCarTypesInCarList?: boolean;
    scMotocycle?: boolean;
    scMovMk?: boolean;
    scPersTM?: boolean;
    scUploadCars?: boolean;
    scCarsCreateDisableFlag?: boolean;
    scTrailer?: boolean;
    scAdditionalCarNumber?: boolean;
    scPayCashFlag?: boolean;
    scSumInfoFlag?: boolean;
    scEditCarWithFreeSaldoFlag?: boolean; // редактирование карточки авто при включеном "бесплатном проезде"
    scFiscalLink?: boolean; // Отчет движения, получить банковский чек
    disableBalance?: boolean; // доступность модуля Баланс
    scShowCurrentPhoto?: boolean; // доступность кнопки "текущее фото" на плитке ШБ

    // Меню.
    parkMkFlag?: boolean; // Настройки -> Парковки
    parkChoiceFlag?: boolean; // Настройки -> Доступ к парковке
    scDeviceStats?: boolean; // Настройки -> Мониторинг
    scSettingsCorp?: boolean; // Настройки -> Корпорация
    scFindDriver?: boolean; // Настройки -> Найти водителя

    // Оплата.
    scCheckPrint?: boolean; // Баланс счета - кнопка счет

    // Доступы к ШБ.
    scFindMovs?: boolean; // Поиск заезда

    // Доступы к отчетам.
    scRptBalance?: boolean;
    scRptCarsBalance?: boolean;
    scRptEvents?: string;
    scRptSvodParks?: boolean;
    scRptAgent?: boolean;
    scRptCarsSvod?: boolean; // Сводная по машинам

    // Модуль Корпорации.
    fltOwnerCorpId?: number; // id родительской корпорации для фильтра таблицы

    // Профиль.
    scUserPersons?: boolean; // Доступ к таблице "Аккаунты"
    reLoginFlag?: boolean; // Переключение корпорации
    hasSavedCards?: boolean;

    // Карточка авто.
    scCorpAdmin?: boolean; // Поле Корпорация
    scDisableCancelMovs?: boolean; // Не переводить в «Условно выехавшие»
    scFreeSaldoFlag?: boolean; // Бесплатный проезд
    scCarsDisableLevenshteinFlag?: boolean; // Строгое совпадение номера

    // ШБ.
    gateDisableFlag?: boolean; // доступность модуля ШБ
    scAutoRefreshGates?: boolean;
    scGateOpen?: boolean;
    scClearGateSum?: boolean; // Обнулить сумму
    scGateEventsLog?: boolean; // Журнал событий
    scHoldOpenGateFlag?: boolean; // Держать ШБ открытым
  }

  export const RECOVER_PASSWORD_EMAIL_NOT_FOUND = 480;

  export interface DataRegistration {
    surName: string;
    firstName: string;
    email: string;
    phone: string;
    carNumber?: string;
  }

  export interface IResponseToken {
    token: string;
  }

  export interface ResourceAuthRegistrationConfirmResponseDataResult {
    login: string;
    password: string;
  }

  export enum CookieName {
    UrlForRedirectAfterLogin = 'redirect_after_auth',
    UserSometimeLogin = 'auth_sometime_login',
  }

  export enum LocalStorageKeys {
    RecoverPasswordCount = 'auth:recover-password-count',
    RecoverPasswordTime = 'auth:recover-password-time',
    RecoverPasswordTimeout = 'auth:recover-password-timeout',
    SuccessLoginCount = 'auth:success-login-count',
    UseRecoverNow = 'auth:use-recover-now',
    LoginSelectCorp = 'auth:login-select-corp',
  }

  export enum EmitterEvents {
    RegistrationSuccess = 'registration:success',
  }
}
